export var AppKind;
(function (AppKind) {
    AppKind["Keyboard"] = "KEYBOARD";
    AppKind["Moral"] = "MORAL";
    AppKind["Block"] = "BLOCK";
    AppKind["Chart"] = "CHART";
    AppKind["Appdesigner"] = "APPDESIGNER";
})(AppKind || (AppKind = {}));
export var CollaborationMode;
(function (CollaborationMode) {
    CollaborationMode["On"] = "ON";
    CollaborationMode["Off"] = "OFF";
})(CollaborationMode || (CollaborationMode = {}));
export var Order;
(function (Order) {
    Order["Asc"] = "ASC";
    Order["Desc"] = "DESC";
})(Order || (Order = {}));
export var PmlFileSort;
(function (PmlFileSort) {
    PmlFileSort["Title"] = "TITLE";
    PmlFileSort["CreatedDatetime"] = "CREATED_DATETIME";
    PmlFileSort["UpdatedDatetime"] = "UPDATED_DATETIME";
})(PmlFileSort || (PmlFileSort = {}));
export var ShuffleMode;
(function (ShuffleMode) {
    ShuffleMode["On"] = "ON";
    ShuffleMode["Off"] = "OFF";
})(ShuffleMode || (ShuffleMode = {}));
export var Stamp;
(function (Stamp) {
    Stamp["VeryGood"] = "VERY_GOOD";
    Stamp["Good"] = "GOOD";
    Stamp["Fight"] = "FIGHT";
    Stamp["VeryWellDone"] = "VERY_WELL_DONE";
    Stamp["WellDone"] = "WELL_DONE";
    Stamp["DoOurBest"] = "DO_OUR_BEST";
    Stamp["None"] = "NONE";
})(Stamp || (Stamp = {}));
//# sourceMappingURL=types.js.map